import { render, staticRenderFns } from "./YFooter.vue?vue&type=template&id=d1f806f2&scoped=true&"
import script from "./YFooter.vue?vue&type=script&lang=js&"
export * from "./YFooter.vue?vue&type=script&lang=js&"
import style0 from "./YFooter.vue?vue&type=style&index=0&id=d1f806f2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f806f2",
  null
  
)

export default component.exports